import { DirectiveBinding } from 'vue/types/options';

import { useMediaQuery } from '../composables/media-query.composable';

import { SKELETON_HEIGHT_SIZE, SKELETON_WIDTH_SIZE } from '../models/constants';

export const SkeletonDirective = {
  bind: (el: any, binding: DirectiveBinding): void => {
    const { isMobile } = useMediaQuery();
    const [height, width, heightMobile, widthMobile] = binding.value.split(',');
    const style = `${SKELETON_HEIGHT_SIZE.get(
      isMobile.value && heightMobile ? heightMobile : height
    )} ${SKELETON_WIDTH_SIZE.get(
      isMobile.value && widthMobile ? widthMobile : width
    )}`;
    el.style = style;
  },
};
